exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-18a76d92] {\n  background-color: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 20px;\n}\n", ""]);

// exports
